import React from 'react';
import Logo from '@components/module-components/logo/Logo';
import Menu from '@components/module-components/menu/Menu';
import Language from '@components/module-components/language/Language';
import logoImage from '@assets/images/logo.png';
import '@components/header/header.scss';

interface ILogoProps {
  logo: string,
  url: string,
  isShowEco?: number,
}

interface IHeaderProps {
  header: ILogoProps,
  haveMenu?: boolean,
}

const Header = ({header, haveMenu = true}: IHeaderProps) => {
  return (
    <header className="header">
      <div className="container">
        <Logo logo={header.logo || logoImage} url={header.logo ? header.url : '/'}/>
        <Language />
        {haveMenu && <Menu  isShowEco={header.isShowEco}/>}
      </div>
    </header>
  );
}

export default Header;
